import React from "react";

const FlashcardStatistics = React.memo(({
  vocabularyList,
  getDueWords,
  getReviewPriority
}) => {
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-8">
      <div className="bg-black/70 border border-cyan-400/50 rounded-xl p-4 text-center hover:shadow-neon-cyan transition-all duration-300">
        <div className="text-2xl font-black font-mono text-cyan-400">
          {vocabularyList.length}
        </div>
        <div className="text-xs text-cyan-300 font-mono">TOTAL UNITS</div>
      </div>
      <div className="bg-black/70 border border-red-400/50 rounded-xl p-4 text-center hover:shadow-neon-pink transition-all duration-300">
        <div className="text-2xl font-black font-mono text-red-400">
          {getDueWords().length}
        </div>
        <div className="text-xs text-red-300 font-mono">DUE REVIEW</div>
      </div>
      <div className="bg-black/70 border border-yellow-400/50 rounded-xl p-4 text-center hover:shadow-neon-green transition-all duration-300">
        <div className="text-2xl font-black font-mono text-yellow-400">
          {vocabularyList.filter((w) => getReviewPriority(w) === "urgent").length}
        </div>
        <div className="text-xs text-yellow-300 font-mono">CRITICAL</div>
      </div>
      <div className="bg-black/70 border border-green-400/50 rounded-xl p-4 text-center hover:shadow-neon-green transition-all duration-300">
        <div className="text-2xl font-black font-mono text-green-400">
          {vocabularyList.filter((w) => w.reviewCount === 0).length}
        </div>
        <div className="text-xs text-green-300 font-mono">NEW UNITS</div>
      </div>
    </div>
  );
});

export default FlashcardStatistics; 